import { RowsEditor, Section, inputCls, labelCls } from "./shared";

const QTY_PRICE = [{ key: "qty", placeholder: "Qty" }, { key: "price", placeholder: "Price" }];

const LIST_FIELDS = [
  ["flavours", "Cake flavours (comma separated)"],
  ["premium_flavours", "Premium flavours (comma separated)"],
  ["dietary", "Dietary options (comma separated)"],
];

export function PricesSection({ prices, update, saving, onSave }) {
  return (
    <Section title="Cupcake Prices" hint="Shown on the Prices page." section="prices" saving={saving} onSave={onSave}>
      <div className="space-y-6">
        <div>
          <p className={`${labelCls} mb-2`}>Mini cupcakes</p>
          <RowsEditor rows={prices.mini} fields={QTY_PRICE} onChange={(rows) => update((c) => (c.prices.mini = rows))} addLabel="Add row" testidPrefix="mini-row" />
        </div>
        <div>
          <p className={`${labelCls} mb-2`}>Regular cupcakes</p>
          <RowsEditor rows={prices.regular} fields={QTY_PRICE} onChange={(rows) => update((c) => (c.prices.regular = rows))} addLabel="Add row" testidPrefix="regular-row" />
        </div>
        <div>
          <p className={`${labelCls} mb-2`}>Extras</p>
          <RowsEditor
            rows={prices.extras}
            fields={[{ key: "name", placeholder: "Extra (e.g. Fondant toppers)" }, { key: "note", placeholder: "Price note (e.g. $10 per 18)" }]}
            onChange={(rows) => update((c) => (c.prices.extras = rows))}
            addLabel="Add extra"
            testidPrefix="extra-row"
          />
        </div>
        <div className="space-y-3">
          {LIST_FIELDS.map(([key, label]) => (
            <div key={key}>
              <label className={labelCls}>{label}</label>
              <input
                value={prices[key].join(", ")}
                onChange={(e) => update((c) => (c.prices[key] = e.target.value.split(",")))}
                data-testid={`content-prices-${key}`}
                className={`${inputCls} w-full`}
              />
            </div>
          ))}
          <div>
            <label className={labelCls}>Premium flavour note</label>
            <input
              value={prices.premium_note}
              onChange={(e) => update((c) => (c.prices.premium_note = e.target.value))}
              data-testid="content-prices-premium-note"
              className={`${inputCls} w-full`}
            />
          </div>
        </div>
      </div>
    </Section>
  );
}

export function ServingsSection({ servings, update, saving, onSave }) {
  return (
    <Section title="Cake Sizes & Servings" hint="Shown on the Size Guide page." section="servings" saving={saving} onSave={onSave}>
      <RowsEditor
        rows={servings}
        fields={[
          { key: "size", placeholder: "Size (e.g. 8′ tall)" },
          { key: "price", placeholder: "Price" },
          { key: "serves", placeholder: "Serves (e.g. 20–30 ppl)" },
        ]}
        onChange={(rows) => update((c) => (c.servings = rows))}
        addLabel="Add size"
        testidPrefix="serving-row"
      />
    </Section>
  );
}
